import { createAction } from '@reduxjs/toolkit';

export const modifyPortalConfig = createAction<{ settingsJson: any }>('portal/modifyPortalConfig');
